import { render, staticRenderFns } from "./ElementFields.vue?vue&type=template&id=965f1132&"
import script from "./ElementFields.vue?vue&type=script&lang=js&"
export * from "./ElementFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports